/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../assets/img/logo/logo-white-3.png";

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Departments", to: "/departments" },
  { label: "Our Doctors", to: "/our-doctors" },
  { label: "Research", to: "/research" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const PATIENT_LINKS = [
  { label: "Book Appointment", to: "/appointment" },
  { label: "Patient Login", to: "/patient-login" },
  { label: "My Appointments", to: "/my-appointments" },
  { label: "My Reports", to: "/my-reports" },
  { label: "FAQs", to: "/faq" },
];

const FooterTwo = (props) => {
  const currentYear = new Date().getFullYear();
  const { footerClass, footerLogo, copyrightClass } = props;
  return (
    <footer>
      <div className={footerClass ? footerClass : "it-footer-area it-footer-style-2 black-bg p-relative fix z-index p-relative"}>
        <div className="container">
          <div className="p-relative" style={{ paddingTop: 64, paddingBottom: 36 }}>
            <div className="row">
              {/* Brand + Contact */}
              <div className="col-xl-4 col-lg-5 col-md-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
                <div className="it-footer-widget-item">
                  <div className="it-footer-logo" style={{ marginBottom: 14 }}>
                    <Link to="/">
                      <img src="images/logo/logo-full.png" alt="Maroof International Hospital" style={{ maxHeight: 72 }} />
                    </Link>
                  </div>
                  <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.85rem", lineHeight: 1.65, marginBottom: 16 }}>
                    Maroof International Hospital — multi-disciplinary tertiary care in F-10 Markaz, Islamabad. Compassionate, world-class
                    healthcare 24/7.
                  </p>

                  <div className="it-footer-widget-contact" style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                    {[
                      { icon: "flaticon-phone-call", label: "Helpline:", href: "tel:+92511116449111", text: "+92-51-111-644-911" },
                      { icon: "flaticon-letter", label: "Email:", href: "mailto:info@maroof.com.pk", text: "info@maroof.com.pk" },
                      {
                        icon: "fa-solid fa-location-dot",
                        label: "Address:",
                        href: "https://www.google.com/maps/search/?api=1&query=Maroof+International+Hospital+F-10+Markaz+Islamabad",
                        text: "F-10 Markaz, Islamabad",
                        external: true,
                      },
                    ].map(({ icon, label, href, text, external }) => (
                      <div key={label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <i
                          className={icon}
                          style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", width: 16, textAlign: "center", flexShrink: 0 }}
                        />
                        <span style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.5)", marginRight: 3, whiteSpace: "nowrap" }}>
                          {label}
                        </span>
                        <a
                          className="hover-anim white"
                          href={href}
                          style={{ fontSize: "0.78rem" }}
                          {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
                        >
                          {text}
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div className="col-xl-2 col-lg-3 col-md-6 col-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".4s">
                <div className="it-footer-widget-item">
                  <p
                    style={{
                      fontSize: "0.68rem",
                      fontWeight: 700,
                      letterSpacing: "0.1em",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,0.35)",
                      marginBottom: 12,
                    }}
                  >
                    Quick Links
                  </p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {QUICK_LINKS.map((l) => (
                      <Link
                        key={l.to}
                        to={l.to}
                        style={{ fontSize: "0.83rem", color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.7)")}
                      >
                        {l.label}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              {/* Patient Services */}
              <div className="col-xl-3 col-lg-4 col-md-6 col-6 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".5s">
                <div className="it-footer-widget-item">
                  <p
                    style={{
                      fontSize: "0.68rem",
                      fontWeight: 700,
                      letterSpacing: "0.1em",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,0.35)",
                      marginBottom: 12,
                    }}
                  >
                    Patient Services
                  </p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                    {PATIENT_LINKS.map((l) => (
                      <Link
                        key={l.to}
                        to={l.to}
                        style={{ fontSize: "0.83rem", color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.7)")}
                      >
                        {l.label}
                      </Link>
                    ))}
                    <a
                      href="https://reports.maroof.com.pk"
                      target="_blank"
                      rel="noreferrer"
                      style={{ fontSize: "0.83rem", color: "rgba(255,255,255,0.7)", textDecoration: "none", transition: "color .2s" }}
                      onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                      onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.7)")}
                    >
                      Online Reports{" "}
                      <i className="fa-regular fa-arrow-up-right-from-square" style={{ fontSize: 10, marginLeft: 3, opacity: 0.6 }}></i>
                    </a>
                  </div>
                </div>
              </div>

              {/* Emergency Card */}
              <div className="col-xl-3 col-lg-12 col-md-12 mb-30 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".6s">
                <div
                  style={{
                    border: "1px solid rgba(255,255,255,0.15)",
                    borderRadius: 12,
                    padding: 18,
                    color: "#fff",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                    <i className="fa-solid fa-truck-medical" style={{ fontSize: 22 }}></i>
                    <h4 style={{ margin: 0, fontSize: "1rem", fontWeight: 800, color: "#fff" }}>24/7 Emergency</h4>
                  </div>
                  <p style={{ margin: "0 0 12px", fontSize: "0.83rem", color: "#d4d4d4" }}>
                    Round-the-clock emergency, ambulance & critical care.
                  </p>
                  <a
                    href="tel:+92511116449111"
                    style={{
                      display: "inline-block",
                      background: "#fff",
                      color: "#b91c1c",
                      fontWeight: 800,
                      padding: "8px 16px",
                      borderRadius: 999,
                      textDecoration: "none",
                      fontSize: "0.88rem",
                    }}
                  >
                    <i className="fa-solid fa-phone" style={{ marginRight: 7 }}></i>
                    111-644-911
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={copyrightClass ? copyrightClass : "it-copyright-area it-copyright-height it-copyright-style-2"}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xxl-2 d-none d-lg-block wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
              <div className="it-copyright-social text-center">
                <span>Follow Us:</span>
                <a
                  href="https://www.facebook.com/MaroofInternationalHospital"
                  target="_blank"
                  rel="noreferrer"
                  className="me-1"
                  aria-label="Facebook"
                >
                  <i className="flaticon-facebook-app-symbol"></i>
                </a>
                <a
                  href="https://www.instagram.com/maroofinternationalhospital"
                  target="_blank"
                  rel="noreferrer"
                  className="me-1"
                  aria-label="Instagram"
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a href="https://www.youtube.com/@MaroofInternationalHospital" target="_blank" rel="noreferrer" aria-label="YouTube">
                  <i className="fa-brands fa-youtube"></i>
                </a>
              </div>
            </div>
            <div className="col-xxl-10 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
              <div className="it-copyright-text text-center text-md-end">
                <p>
                  Copyright © {currentYear} <Link to="/">Maroof International Hospital</Link> · All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;
